import styled from "styled-components";

function Recommend(props){
    return(
        <RecommendBlock>
            <Block>
                <Layout>
                    <img className="img" src={props.img} alt={props.altImg}/>
                    <Title className="h-2">
                        {props.title}
                    </Title>
                    <Description>
                        {props.description}
                    </Description>
                    <AuthorBlock>
                        <div className="author f-inter">
                            {props.author}
                        </div>
                        <div className="authorPosition">
                            {props.authorPosition}
                        </div>
                    </AuthorBlock>
                </Layout>
            </Block>
            <Poster>
                <img className="img" src={props.poster} alt={props.altPoster}/>
            </Poster>
        </RecommendBlock>
    );
}
const RecommendBlock = styled.div`
  position:relative;
`;
const Block = styled.div`
  position:relative;
  
  background-color:white;
  color:black;
  padding:60px;
  border-radius: 20px;
  
  height: 400px;
  .img{
    max-width: 250px;
    padding-bottom:10px;
  }
  @media only screen and (max-width: 600px){
    padding:40px;
  }
  @media only screen and (max-width: 999px){
    height: fit-content;
    padding-bottom: 160px;
  }
`;
const Layout = styled.div`
  width: 54%;
  @media only screen and (max-width: 999px){
    width: auto;
  }
`;
const Poster = styled.div`
  position:absolute;
  top: 50%;
  right: -30%;
  overflow-y:hidden;
  transform: translate(-50%, -50%);
  .img{
    width: 600px; 
    border-radius: 20px;
  }
  @media only screen and (min-width: 1099px) and (max-width: 1400px){
    right: -30%;
    .img{
      width:450px;
    }
  }
  @media only screen and (min-width: 1000px) and (max-width: 1098px){
    right: -20%;
    .img{
      width: 350px;
    }
  }
  @media only screen and (max-width: 999px){
    display:none;
  }
`;
const Title = styled.div`
  padding-bottom:10px;
`;
const Description = styled.div`
  font-style:italic;
  font-size:24px;
  @media only screen and (max-width: 600px){
    font-size:16px;
  }
`;
const AuthorBlock = styled.div`
  position:absolute;
  bottom:60px;
  .author{
    font-weight: bold;
  }
`;
export default Recommend;